<template>
    <div>
        <section class="relative overflow-auto mb-1 md:mb-2">
            <button class="fixed right-0 bottom-0 m-6 z-30 flex block p-0 bg-wasap-2 text-secondary rounded-full active:shadow-lg mouse shadow transition ease-in delay-1000 duration-700 focus:outline-none">
                <a href="https://wa.me/584128002579" class="flex">
                <p class="hidden md:block my-auto m-2 text-xs font-semibold">Conversa con nosotros</p> 
                    <img class="rounded-full" src="@/assets/media/ws-green.svg" width="30" height="30">
                </a>
            </button>
           
            <div class="container px-5 mt-16 mb-4 mx-auto flex sm:flex-no-wrap flex-wrap md:mt-24 md:mb-2">
                <div class="lg:w-2/3 md:w-1/2 bg-gray-300 rounded-lg overflow-hidden sm:mr-10 p-2 flex items-end justify-start relative">
                    <iframe width="100%" height="100%" class="absolute inset-0" frameborder="0" title="map" marginheight="0" marginwidth="0" scrolling="no" src="https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d15692.607643519337!2d-66.8818843!3d10.4886885!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x8c2a58ddc7d94797%3A0x81d370c19e7244d4!2sEdificio%20Pigalle!5e0!3m2!1ses!2sve!4v1714841239349!5m2!1ses!2sve" style="filter: grayscale(1) contrast(0.8) opacity(0.7);"></iframe>
                    <div class="bg-secondary border border-primary rounded-lg bg-opacity-75 relative flex flex-wrap py-6 md:bg-opacity-100">
                        <div class="lg:w-1/2 px-6">
                            <h2 class="title-font font-bold text-gray-900 tracking-widest text-sm">UBICANOS</h2>
                            <p class="leading-relaxed mt-4">En la Urb. Bello Monte,<br/>
                                Edif. Pigalle Piso 10, Ofc. 101,
                                Caracas.</p>
                        </div>
                        <div class="lg:w-1/2 px-6 mt-4 lg:mt-0">
                            <h2 class="title-font font-bold tracking-widest text-sm">E-MAIL</h2>
                            <a class="text-indigo-500 leading-relaxed">inversionescios@gmail.com</a>
                            <h2 class="title-font font-bold text-gray-900 tracking-widest text-sm mt-4">TELEFONO</h2>
                            <p class="leading-relaxed">+58 412 800 25 79</p>
                        </div>
                    </div>
                </div>
                <div class="lg:w-1/3 md:w-1/2 bg-secondary  border border-primary rounded-lg p-4 flex flex-col md:ml-auto w-full md:py-8 mt-8 md:mt-0">
                    <img class="absolute p-6 right-0 opacity-10" src="@/assets/cios-dress.svg" style="max-height: 52rem;" />
                    <div class="relative flex flex-col">
                        <h1 class="text-gray-900 text-4xl mb-1 text-center">Contáctanos</h1>
                        <p class="leading-relaxed mb-5 text-gray-600 text-center">Cios Alquiler de Vestidos</p>
                        <input class="bg-white rounded border border-gray-400 focus:outline-none focus:border-indigo-500 text-base px-4 py-2 mb-4" placeholder="Nombre" type="text" v-model="nombre">
                        <input class="bg-white rounded border border-gray-400 focus:outline-none focus:border-indigo-500 text-base px-4 py-2 mb-4" placeholder="Email" type="email" v-model="email">
                        <textarea class="bg-white rounded border border-gray-400 focus:outline-none h-32 focus:border-indigo-500 text-base px-4 py-2 mb-4 resize-none" placeholder="Mensaje" v-model="texto"></textarea>
                        <a class="text-secondary bg-primary border-0 py-2 px-6 focus:outline-none rounded text-lg" :href="escribe" @click="contacto">
                            <p class="w-full text-center">Escribenos</p>
                        </a>
                        <p class=" text-center mt-4">Caracas, Venezuela</p>
                        <p class=" text-center text-sm">All rights reserved.</p>
                        <p class=" text-center font-bold mb-2 ml-4 text-sm">2020 ©</p>
                    </div>
                </div>
            </div>
        </section>
        <Contacto />
    </div>
</template>
<script>
import Contacto from '@/components/contacto.vue'
import firebase_anal from 'firebase'
export default {
    components: {
        Contacto
    },
    data() {
        return {
            texto: '',
            email: '',
            nombre: '',
            //enlace: 'https://wa.me/584128002579?text=',
            enlace: 'mailto:inversionescios@gmail.com'
        }
    },
    methods:{
        contacto(){
            //console.log('Aqui tu metodo crack')
            firebase_anal.analytics().logEvent('ad_click', { name: 'contacto_mail'});
        }
    },
    computed: {
        escribe() {
            return 'mailto:inversionescios@gmail.com?subject='
        + encodeURIComponent(this.email+' '+this.nombre)
        + "&body=" + encodeURIComponent(this.texto);
            //return this.enlace + this.texto.replace(/ /gi, "%20")
        }
    }
}
</script>

<style scoped>

h1 {
    font-family: "Playfair Display", serif;
    font-style: italic;
}
</style>